import { ComponentProps, FC, ReactElement } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Box, Popover, Ribbon as RibbonPrimitive, Stack, Text, TextLink } from '@eneco/sparky';
import { InfoIcon } from '@eneco/sparky/icons';
import { DC_Repositories_Base_Enumerations_Label } from '@monorepo-types/dc';

type RibbonProps = Pick<ComponentProps<typeof RibbonPrimitive>, 'size' | 'emphasis'>;

interface Props {
  theme?: DC_Repositories_Base_Enumerations_Label;
  size?: RibbonProps['size'];
  emphasis?: RibbonProps['emphasis'];

  title: string;
  text?: string;
  trigger?: string;
  icon?: ReactElement;
}

export const Ribbon: FC<Props> = ({ theme = 'eneco', size = 'large', emphasis, title, text, trigger, icon }) => (
  <RibbonPrimitive emphasis={emphasis} size={size}>
    <Stack gap="2" alignX="center" alignY="center" direction="row">
      <Stack.Item>{icon}</Stack.Item>
      <Stack.Item>
        <Box paddingTop={theme === 'eneco' ? 1 : 0}>
          <Text weight="bold" size={size === 'small' ? {} : { initial: 'BodyXS', sm: 'BodyS' }}>
            <RichText html={title} />{' '}
            {trigger && text && (
              <Popover
                side="bottom"
                title={title}
                trigger={
                  <TextLink
                    leftIcon={
                      <InfoIcon
                        size="small"
                        verticalAlign={size === 'large' ? 'middle' : 'bottom'}
                        color={'currentColor'}
                      />
                    }>
                    {trigger}
                  </TextLink>
                }>
                <RichText html={text} />
              </Popover>
            )}
          </Text>
        </Box>
      </Stack.Item>
    </Stack>
  </RibbonPrimitive>
);
